/**
 * parse json from fetch response
 * @param  {object} response fetch response object
 * @return {object}          parsed object
 */
export default function parseJSON(response) {
  return response.json();
}



// WEBPACK FOOTER //
// ./app/utils/http/parseJSON.js